import { Input, Space } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const genCode = () => Array.from({ length: 4 }, () => CHARS[Math.floor(Math.random() * CHARS.length)]).join('');

function drawCaptcha(canvas: HTMLCanvasElement, code: string) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const w = canvas.width;
  const h = canvas.height;
  ctx.fillStyle = '#f0f2f5';
  ctx.fillRect(0, 0, w, h);
  // 噪点
  for (let i = 0; i < 30; i++) {
    ctx.fillStyle = `rgba(${Math.random() * 200},${Math.random() * 200},${Math.random() * 200},0.3)`;
    ctx.fillRect(Math.random() * w, Math.random() * h, 2, 2);
  }
  // 干扰线
  for (let i = 0; i < 3; i++) {
    ctx.strokeStyle = `rgba(${Math.random() * 200},${Math.random() * 200},${Math.random() * 200},0.6)`;
    ctx.beginPath();
    ctx.moveTo(Math.random() * w, Math.random() * h);
    ctx.lineTo(Math.random() * w, Math.random() * h);
    ctx.stroke();
  }
  // 字符
  ctx.font = 'bold 22px sans-serif';
  ctx.textBaseline = 'middle';
  for (let i = 0; i < code.length; i++) {
    ctx.fillStyle = `rgb(${Math.random() * 100},${Math.random() * 100},${Math.random() * 100})`;
    ctx.save();
    const x = (w / code.length) * i + 8;
    const y = h / 2 + (Math.random() - 0.5) * 6;
    ctx.translate(x, y);
    ctx.rotate((Math.random() - 0.5) * 0.4);
    ctx.fillText(code[i], 0, 0);
    ctx.restore();
  }
}

export interface CaptchaInputHandle {
  validate: (input: string) => boolean;
  refresh: () => void;
}

interface Props {
  value?: string;
  onChange?: (v: string) => void;
}

export const CaptchaInput = forwardRef<CaptchaInputHandle, Props>(({ value, onChange }, ref) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [code, setCode] = useState(genCode);

  useEffect(() => {
    if (canvasRef.current) drawCaptcha(canvasRef.current, code);
  }, [code]);

  useImperativeHandle(ref, () => ({
    validate: (input) => input.trim().toUpperCase() === code,
    refresh: () => setCode(genCode()),
  }));

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder="图形验证码"
        maxLength={4}
        style={{ flex: 1 }}
      />
      <canvas
        ref={canvasRef}
        width={100}
        height={32}
        onClick={() => setCode(genCode())}
        title="点击刷新"
        style={{ cursor: 'pointer', borderRadius: 4, border: '1px solid #d9d9d9', borderLeft: 'none' }}
      />
    </Space.Compact>
  );
});
